import { createStore } from "zustand/vanilla";
import { errorToMessage } from "../errorToMessage.js";
export const createArchiveStore = (deps) => {
    // Stream subscriptions are owned by the store: dispose() unsubscribes them all, so a
    // superseded store stops writing into state nothing renders. `subs` is filled after
    // the store exists (the streams push into it).
    const subs = [];
    const store = createStore((set) => ({
        trips: [],
        templates: [],
        error: null,
        async unarchiveTrip(id) {
            const r = await deps.trips.archiveTrip(id, false);
            if (!r.ok)
                set({ error: errorToMessage(r.error) });
            return r;
        },
        async deleteTrip(id) {
            const r = await deps.trips.deleteTrip(id);
            if (!r.ok)
                set({ error: errorToMessage(r.error) });
            return r;
        },
        async unarchiveTemplate(id) {
            const r = await deps.templates.archiveTemplate(id, false);
            if (!r.ok)
                set({ error: errorToMessage(r.error) });
            return r;
        },
        async deleteTemplate(id) {
            const r = await deps.templates.deleteTemplate(id);
            if (!r.ok)
                set({ error: errorToMessage(r.error) });
            return r;
        },
        dispose() {
            for (const unsubscribe of subs.splice(0))
                unsubscribe();
        },
    }));
    subs.push(deps.trips.observeMyTrips(deps.userId, { archived: true }).subscribe((trips) => store.setState({ trips })), deps.templates
        .observeMyTemplates(deps.userId, { archived: true })
        .subscribe((templates) => store.setState({ templates })));
    return store;
};
//# sourceMappingURL=archiveStore.js.map